import { useCallback, useEffect, useRef, useState } from "react";

import type { CarouselApi } from "~/components/ui/carousel";

export const useAnswerCarouselState = () => {
    const carouselRef = useRef<HTMLDivElement>(null);
    const [emblaApi, setEmblaApi] = useState<CarouselApi>();
    const [activeIndex, setActiveIndex] = useState(0);
    const [isInteracted, setIsInteracted] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const activateSlide = useCallback((index: number) => {
        setActiveIndex(index);
        setIsInteracted(true);
    }, []);

    useEffect(() => {
        const carousel = carouselRef.current;
        if (!carousel) return;

        const observer = new IntersectionObserver(([entry]) => {
            setIsVisible(Boolean(entry?.isIntersecting));
        });

        observer.observe(carousel);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (!emblaApi) return;

        const onSelect = () => {
            activateSlide(emblaApi.selectedScrollSnap());
        };

        emblaApi.on("select", onSelect);
        return () => {
            emblaApi.off("select", onSelect);
        };
    }, [activateSlide, emblaApi]);

    return {
        activateSlide,
        activeIndex,
        carouselRef,
        emblaApi,
        isInteracted,
        isVisible,
        setEmblaApi,
    };
};
